import DOMPurify from 'dompurify'

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'strike',
  'h1',
  'h2',
  'h3',
  'ul',
  'ol',
  'li',
  'blockquote',
  'pre',
  'code',
  'a',
  'figure',
  'figcaption',
  'img',
  'video',
  'source',
]

const ALLOWED_ATTR = ['href', 'target', 'rel', 'src', 'alt', 'loading', 'controls', 'preload', 'type', 'class']

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

export const sanitizeMessageHtml = (html) => {
  if (!html?.trim()) return ''

  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR }).trim()
}
